import { dispatch } from "./StoreUtils";
import { TempDataActions } from "@my-dld/actions";
import React, { ChangeEvent } from "react";
import { ErrorContainer } from "@eres/forms";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LVStrings } from "@my-dld/assets/strings";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { MessageDataOptions } from "@my-dld/reducers/TempData";
import { StringUtil } from "@eres/core";

export function setLoaderClass( className?: string ) {
	dispatch( TempDataActions.LOADER_CSS_CLASS, className );
}

export function showLoading() {
	dispatch( TempDataActions.ON_LOAD_DATA );
}

export function hideLoading() {
	dispatch( TempDataActions.ON_LOAD_DATA_DONE );
}

export function showMessage( message: string ) {
	dispatch( TempDataActions.SHOW_MESSAGE, message );
}

export function showInfo( message: string, options?: MessageDataOptions ) {
	if ( options == null )
		options = { icon: "info" };
	dispatch( TempDataActions.SHOW_INFO, { message, options } );
}

export function getError( message: any ): string | undefined {
	const t = typeof ( message as any );
	switch ( t ) {
		case "undefined":
			return;
		case "object":
			const x = message as any;
			if ( x[ "message" ] ) {
				message = x.message;
			} else if ( x[ "Message" ] ) {
				message = x.Message;
			} else {
				message = x.toString();
			}
			break;
		case "boolean":
			message = message.toString();
			break;
		case "number":
			message = message.toString();
			break;
		case "string":
			break;
		case "function":
			return;
		case "symbol":
			message = message.toString();
			break;
		case "bigint":
			message = message.toString();
			break;

	}
	return message;
}

export function showErrorMessage( message: string ) {
	const m = getError( message );
	if ( m && !StringUtil.isEmptyStringOrNull( m ) )
		dispatch( TempDataActions.SHOW_ERROR, m );
}

export function showUnverifiedEmailError() {
	JQModal( "unverifiedEmail" ).show();
}

const regex = /^(.{3})(.{4})(.{7})(.*)/;
const subst = `$1-$2-$3-$4`;

export function eidFormat( eid?: string ) {
	let value = eid;
	if ( value ) {
		value = value.replace( /[^0-9]/g, "" );
		value = value.replace( regex, subst );
		return value;
	} else return "-";
}

export function getSelectedPickerItem( e: ChangeEvent<HTMLSelectElement> ): HTMLOptionElement | undefined {
	if ( e.target.selectedOptions && e.target.selectedOptions.length > 0 ) {
		return e.target.selectedOptions[ 0 ];
	} else {
		const ox = e.target.selectedIndex;
		if ( ox != -1 )
			return e.target[ e.target.selectedIndex ] as HTMLOptionElement;
	}
	return undefined;
}

const englishRegex = /[a-zA-Z ]+$/;
const arabicRegex = /[\u0600-\u06ff ]+$/;

export function isEnglishChar( input: string ) {
	return englishRegex.test( input );
}

export function isArabicChar( input: string ) {
	return arabicRegex.test( input );
}

export interface LoadableDataState {
	loadState: "loading" | "done" | "error";
	errorMessages?: string[];
	errorContainer: ErrorContainer;
}

enum DataViewTypeId {
	LIST = 1,
	GRID = 2,
	MAP = 3,
}

export interface DataViewType {
	Id: number;
	name: LocaleValue;
}

export const ListView: DataViewType = {
	Id: DataViewTypeId.LIST,
	name: LVStrings.list,
};

export const GridView: DataViewType = {
	Id: DataViewTypeId.GRID,
	name: LVStrings.grid,
};

export const MapView: DataViewType = {
	Id: DataViewTypeId.MAP,
	name: LVStrings.map,
};

export function $( x: any ): any {
	return window.$( x );
}

type LoadableState<S = {}> = S & { isLoading?: boolean };
type LoadableCmp<S = {}> = React.Component<any, LoadableState<S>>

export function setLoading<S extends object>( target: LoadableCmp<S>, isLoading: boolean, extraState: Partial<S> = {}, cb?: () => void ) {
	target.setState( {
		...extraState,
		isLoading: isLoading,
	} as S, cb );
}
